import React from "react";
import SubItemMenuAlumno from "./components/SubItemMenuAlumno";
import { useSearchParams, useNavigate } from "react-router-dom";
import UniversalIconPerfil from "../UniversalIconoPerfil/UniversalIconPerfil";

export default function UniversalMenuAlumno() {
  const navigate = useNavigate();

  const mCerrarSesion = () => {
    localStorage.clear();

    navigate("/");
  };

  return (
    <div data-figma-id="4460:19152" class="skill-menu">
      <div data-figma-id="4460:19059" class="skill-menu-titulo">
        <i class="fi fi-rs-burger-menu img-59"></i>

        <div data-figma-id="4460:19110" class="logo-sin-manzana-blanco-1">
          <img
            src={`${window.location.origin}/images/logo.png`}
            data-figma-id="113:9430"
            className="img"
            alt="Logo"
            onClick={() => navigate("?f=i", { replace: true })}
            style={{ cursor: "pointer" }} // Para mejorar UX, me dio flojera usar webflow XD
          />
        </div>
        <div data-figma-id="810:15670" class="header-iconos-tablet">
            <i class="fi fi-rs-bell bell-1-2"></i>
            <UniversalIconPerfil />
        </div>
      </div>
      <div class="home-linea-header"></div>
      <div class="div-block-10">
        <div data-figma-id="4460:19062" class="skill-menu-contenido">
          <SubItemMenuAlumno
            vTexto="Inicio"
            vIcon="fi fi-rs-house-chimney"
            vNombreFrame="i"
          />
          <SubItemMenuAlumno
            vTexto="Mis cursos"
            vIcon="fi fi-rs-lesson"
            vNombreFrame="mc"
          />
          <SubItemMenuAlumno
            vTexto="Perfil"
            vIcon="fi fi-rs-user-graduate"
            vNombreFrame="p"
          />
          <div
            data-figma-id="4460:19179"
            class="configuracion-menu-cel"
            onClick={mCerrarSesion}
          >
            <div data-figma-id="4460:19185" class="cerrar-sesion">
              <i class="fi fi-rs-exit img-64"></i>
            </div>
            <p data-figma-id="4460:19181" class="item-menu-texto-panel-admin">
              Cerrar Sesión
            </p>
          </div>
        </div>
        <div
          data-figma-id="4460:19179"
          class="configuracion-menu"
          onClick={mCerrarSesion}
        >
          <div data-figma-id="4460:19185" class="cerrar-sesion">
            <i class="fi fi-rs-exit img-64"></i>
          </div>
          <p data-figma-id="4460:19181" class="item-menu-texto-panel-admin">
            Cerrar Sesión
          </p>
        </div>
      </div>
    </div>
  );
}
